import { useFormContext, type RegisterOptions } from 'react-hook-form'
import { cn } from '#/lib/utils'

type FormTextareaProps = {
  name: string
  label: string
  placeholder?: string
  rows?: number
  icon?: React.ReactNode
  rules?: RegisterOptions
  className?: string
}

export function FormTextarea({
  name,
  label,
  placeholder,
  rows = 5,
  icon,
  rules,
  className,
}: FormTextareaProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const error = errors[name]?.message as string | undefined

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={name} className="text-sm font-medium text-neutral-700">
        {label}
        {rules?.required && <span className="ml-1 text-primary-400">*</span>}
      </label>

      <div
        className={cn(
          'relative overflow-hidden rounded-xl border bg-white  transition-all duration-200 focus-within:border-primary-500/60 focus-within:shadow-[0_0_0_3px_rgba(255,182,6,0.10)]',
          error
            ? 'border-red-500/60'
            : 'border-neutral-200 hover:border-neutral-300',
        )}
      >
        {icon && (
          <span className="pointer-events-none absolute left-4 top-3.5 text-neutral-400">
            {icon}
          </span>
        )}
        <textarea
          id={name}
          placeholder={placeholder}
          rows={rows}
          {...register(name, rules)}
          className={cn(
            'w-full resize-none bg-transparent pb-4 pr-4 pt-3 text-sm  placeholder:text-neutral-500 outline-none',
            icon ? 'pl-11' : 'pl-4',
          )}
        />
      </div>

      {error && <p className="text-xs text-red-400">{error}</p>}
    </div>
  )
}
